import type { UserId } from "@/spz-api/model";
import type { TFunction } from "i18next";
import * as z from "zod";

const userIdSchema = z
  .custom<UserId>()
  .transform((val) => val as unknown as UserId);

export const userGroupsFormSchema = (t: TFunction) => {
  return z.object({
    name: z.string().nonempty(t("field_required")),
    description: z.string().optional(),
    users: z.array(userIdSchema).optional(),
    updatedAt: z.string().optional(),
  });
};

export type UserGroupsFormSchemaValues = z.infer<
  ReturnType<typeof userGroupsFormSchema>
>;
